module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAByBAMAAADUh1DaAAAAIVBMVEUAAAD/th7/th7/th7/th7/th7/th7/th7/th7/th7/th6u0VxrAAAACnRSTlMAsfPMvDcuHXBvjs5waQAAAIZJREFUWMPtkq0Ng2AAREmatmldTZt0AoJCo8EjGAA2gA2YgQn4cTcl6EsORwJf7omnnnwRcc9LLeLxx1RLUfwGMEoFEN8ApFIRMSDWYp6fVus4/Ibf8Bt+w2/4DWNMKFSFFtMAXy0CG1IhxBmwaBGvZO61mO6ntYffOEnsN/yG3/Ab13xjBSZVtHanG78GAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/serviceIcon.png
// module id = /6hz
// module chunks = 1